import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MessageDialogData } from '../../../interfaces/dialog';
import { DialogRef } from '@ngneat/dialog';
import { SafePipe } from '../../../pipes/safe.pipe';
import { DataTestDirective } from '@outlaw/core';

@Component({
  selector: 'ol-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  imports: [SafePipe, DataTestDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageDialogComponent {
  public dialogRef = inject<DialogRef<MessageDialogData>>(DialogRef);

  get dialogData(): MessageDialogData {
    return this.dialogRef.data;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
